<template>
    <div class="inner-box">
        <div class="content-name">
            <h2 class="dp-ib">{{ title }}</h2>
            <div class="btn-wrap btn-type1 clearfix">
                <button class="btn-size btn-blue fl_left" @click="goSearch"><span class="btn-icon"><i
                        class="fas fa-pen-alt"></i></span> 조회
                </button>
            </div>
        </div>

        <!-- 검색조건 영역 -->
        <div class="desc-content search-border">
            <div class="item desc-left">
                <div class="desc-item">
                    <div class="tit">
                        <span class="label-tit">방문상태</span>
                    </div>
                    <div class="desc" style="width: 70%;">
                        <b-select class="select is-fullwidth" v-model="form.visitorStatCd" style="float: left">
                            <option value=''>==전체==</option>
                            <option
                                    v-for="item in visitorStats"
                                    :key="item.key"
                                    :value="item.key"
                                    v-text="item.value"/>
                        </b-select>
                        <div v-if="isWait">
                            <input type="checkbox" id="exceptChk" v-model="form.exceptToday"><label
                                for="exceptChk"><span style="font-size: 14px">오늘 방문한 사람 제외</span></label>
                        </div>
                    </div>
                </div>

                <div class="desc-item">
                    <div class="tit">
                        <span class="label-tit">진행상태</span>
                    </div>
                    <div class="desc" style="width: 70%">
                        <b-select class="select is-fullwidth" v-model="form.visitStatCd"
                                  :disabled="form.visitorStatCd === '' ? false:true">
                            <option value=''>==전체==</option>
                            <option
                                    v-for="item in visitStats"
                                    :key="item.key"
                                    :value="item.key"
                                    v-text="item.value"/>
                        </b-select>
                    </div>
                </div>

                <div class="desc-item">
                    <div class="tit">
                        <span class="label-tit">방문일자</span>
                    </div>
                    <div class="desc">
                        <div class="datepicker w-type-ymd02">
                            <dhx-calendar class="input ddate sDate" v-model="form.searchVDtmFr"
                                          :disabled="form.visitorStatCd === 'DONE' ? true:false"/>
                        </div>
                        <span class="wave"> ~ </span>
                        <div class="datepicker w-type-ymd02">
                            <dhx-calendar class="input ddate sDate" v-model="form.searchVDtmTo"
                                          :disabled="form.visitorStatCd === 'DONE' ? true:false"/>
                        </div>
                        <div class="btn-wrap btn-type2 clearfix"
                             style="float:left; padding-left: 5px; padding-top: 2px; margin-bottom: 0px">
                            <button class="btn-size btn-w-gray" @click="setToday()"
                                    style="height: 22px; padding: 0 8px; font-size: 12px">
                                오늘
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item desc-center">
                <div class="desc-item" v-if="this.visitBookYn">
                    <div class="tit">
                        <span class="label-tit">접수유형</span>
                    </div>
                    <div class="desc" style="width: 70%">
                        <b-select class="select is-fullwidth" v-model="form.visitTypeCd">
                            <option value=''>==전체==</option>
                            <option
                                    v-for="item in visitTypes"
                                    :key="item.key"
                                    :value="item.key"
                                    v-text="item.value"/>
                        </b-select>
                    </div>
                </div>
                <div class="desc-item">
                  <div class="tit">
                    <span class="label-tit">방문회사</span>
                  </div>
                  <div class="desc" style="width: 70%">
                    <b-select class="select is-fullwidth" v-model="form.visitCompCd">
                      <option value=''>==전체==</option>
                      <option value='100010'>일진전기</option>
                      <option value='100002'>일진홀딩스</option>
                      <option value='101301'>일진다이아</option>
                      <option value='222300'>알피니언메디칼</option>
                    </b-select>
                  </div>
                </div>
                <search-dept-mg title="방문부서" v-model="form"
                             :options="{ type: '01', deptCd: 'visitDept', deptNm: 'deptNm', authorize: true }"
                             @submit="goSearch" style="width: 100%;"/>
                <search-emp-mg title="피방문자" v-model="form"
                            :options="{ type: '01', empNo: 'visitEmp', empNm: 'empNm', dutNm: 'wrtDutNm', deptNm: 'wrtCctrNm' }"
                            @submit="goSearch" style="width: 100%;"/>
            </div>
            <div class="item desc-right">
                <div class="desc-item" style="width: 80%">
                    <div class="tit">
                        <span class="label-tit">신청자명</span>
                    </div>
                    <div class="desc">
                        <input class="input Rt-M tal" type="text" v-model="form.visitorFirstNm"
                               @keypress.enter.prevent="goSearch">
                    </div>
                </div>
                <div class="desc-item" style="width: 80%">
                    <div class="tit">
                        <span class="label-tit">방문자명</span>
                    </div>
                    <div class="desc">
                        <input class="input Rt-M tal" type="text" v-model="form.visitorNm"
                               @keypress.enter.prevent="goSearch">
                    </div>
                </div>
                <div class="desc-item" style="width: 80%">
                    <div class="tit">
                        <span class="label-tit">회사명</span>
                    </div>
                    <div class="desc">
                        <input class="input Rt-M tal" type="text" v-model="form.visitorComp"
                               @keypress.enter.prevent="goSearch">
                    </div>
                </div>
            </div>
        </div>
        <!-- //검색조건 영역 -->

        <!-- 테이블 -->
        <div class="table-area">
            <div class="table-b">
                <div class="table-header">
                    <div class="table-name">
                        <h3 class="ico_table_name">방문객 목록</h3>
                    </div>
                    <div class="btn-wrap btn-type1 clearfix">
                        <button class="btn-size btn-excel" @click="saveExcel">엑셀 저장</button>
                    </div>
                </div>
                <div class="grid-wrap">
                    <dhx-grid ref="grid" v-model="visitList" :config="config"
                              @constructGridSuccessful="constructGridSuccessful"/>
                </div>
                <!-- 엑셀 다운로드를 위한 그리드 -->
                <div class="grid-wrap" style="display: none;">
                    <dhx-grid ref="gridExcel" v-model="visitList" :config="configExcel"
                              @constructGridSuccessful="constructGridSuccessful"/>
                </div>
            </div>
        </div>
        <!-- //테이블 -->

        <!--팝업-->
        <b-modal :active.sync="showEmpModal" has-modal-card @receive="receiveEmp">
            <emp :param="form.draftNm"></emp>
        </b-modal>
        <!--//팝업 -->
    </div>
</template>

<script>
import mixin from '@/mixin';
import mixinSlip from '@/mixin/slip';
import _ from 'lodash'

import DhxCalendar from '@/components/DhxCalendar.vue'
import DhxGrid from '@/components/DhxGrid.vue'
import Emp from '@/components/Emp.vue';
import SecuDetail from '@/components/SecuDetail.vue'
import CarDetail from '@/components/CarDetail.vue'
import SearchDeptMg from '@/components/SearchDeptMg.vue';
import SearchEmpMg from '@/components/SearchEmpMg.vue';


export default {
    name: 'VisitorIngMgList',
    mixins: [mixin, mixinSlip],
    components: {Emp, DhxGrid, DhxCalendar, SecuDetail, CarDetail, SearchDeptMg, SearchEmpMg},
    data() {
        return {
            config: {
                columns: [
                    {id: 'no', type: 'cntr', align: 'center', sort: 'na', value: 'No.', width: 35},
                    {
                        id: 'inOut',
                        value: '입퇴실처리',
                        component: {
                            props: ['index', 'value', 'field'],
                            template: `
                                <div class="btn-wrapper" v-if="this.show ==='Y'">
                                <button type="button" class="btn btn-primary btn-block" @click="doInProcess()">입실
                                </button>
                                </div>
                                <div class="btn-wrapper" v-else-if="this.show ==='N'">
                                <button type="button" class="btn btn-orange btn-block" @click="doOutProcess()">퇴실
                                </button>
                                </div>
                                <div class="btn-wrapper" v-else-if="this.show ==='R'">
                                <button type="button" class="btn btn-default btn-block" @click="showRefuse()">거부됨
                                </button>
                                </div>
                                <div class="btn-wrapper" v-else-if="this.show ==='F'">
                                <button type="button" class="btn btn-default btn-block" @click="showAlert()">미해당
                                </button>
                                </div>`,
                            data() {
                                return {show: ''}
                            },
                            mounted() {
                                this.checkTime()
                            },
                            methods: {
                                doInProcess() {
                                    this.$http.post(`/api/visit/checkVisitorTime`, this.$parent.value[this.index]
                                    ).then((response) => {
                                        this.show = response.data === 0 ? 'Y' : 'N';
                                        if (this.show === 'Y') {
                                            this.$swal({
                                                type: 'info',
                                                text: `입실처리를 진행합니다. 계속 하시겠습니까?`,
                                                showCancelButton: true,
                                                confirmButtonText: '예',
                                                cancelButtonText: '아니오',
                                            }).then((result) => {
                                                if (result.value) {
                                                    this.$http.post(`/api/visit/save/visitor/inTime`, this.$parent.value[this.index]
                                                    ).then((response) => {
                                                        this.$swal({
                                                            type: 'success', text: '완료되었습니다.'
                                                        }).then((result) => {
                                                            this.$parent.$parent.goSearch()
                                                        });
                                                    }).catch((e) => {
                                                        console.error(e);
                                                    });
                                                }
                                            });
                                        } else {
                                            this.$swal({
                                                type: 'error', text: '입실 내역이 있습니다. 확인 후 작업해주세요.'
                                            }).then((result) => {
                                                this.$parent.$parent.goSearch()
                                            })
                                        }
                                    }).catch((e) => {
                                        console.error(e);
                                    })
                                },
                                doOutProcess() {
                                    this.$http.post(`/api/visit/checkVisitorTime`, this.$parent.value[this.index]
                                    ).then((response) => {
                                        this.show = response.data === 0 ? 'Y' : 'N';
                                        if (this.show === 'N') {
                                            this.$swal({
                                                type: 'info',
                                                text: `퇴실처리를 진행합니다. 계속 하시겠습니까?`,
                                                showCancelButton: true,
                                                confirmButtonText: '예',
                                                cancelButtonText: '아니오',
                                            }).then((result) => {
                                                if (result.value) {
                                                    this.$http.post(`/api/visit/save/visitor/outTime`, this.$parent.value[this.index]
                                                    ).then((response) => {
                                                        this.$swal({
                                                            type: 'success', text: '완료되었습니다.'
                                                        }).then((result) => {
                                                            this.$parent.$parent.goSearch()
                                                        });
                                                    }).catch((e) => {
                                                        console.error(e);
                                                    });
                                                }
                                            });
                                        } else {
                                            this.$swal({
                                                type: 'error', text: '퇴실할 내역이 없습니다. 확인 후 작업해주세요.'
                                            }).then((result) => {
                                                this.$parent.$parent.goSearch()
                                            })
                                        }
                                    }).catch((e) => {
                                        console.error(e);
                                    })
                                },
                                showRefuse() {
                                    this.$swal({
                                        type: 'error', text: '결재과정에서 거부처리된 인원입니다.'
                                    })
                                },
                                showAlert() {
                                    this.$swal({
                                        type: 'error', text: '입퇴실 조건에 해당되지 않습니다.'
                                    })
                                },
                                checkTime() {
                                    let staDt = this.$parent.$parent.toPure(this.$parent.value[this.index].staYmd)
                                    let endDt = this.$parent.$parent.toPure(this.$parent.value[this.index].endYmd)

                                    if (parseInt(this.index / 12) != this.$parent.page)
                                        return

                                    this.$http.post(`/api/visit/checkVisitorTime`, this.$parent.value[this.index]
                                    ).then((response) => {
                                        if (response.data !== 0) {
                                            this.show = 'N'
                                        } else {
                                            if (this.$parent.value[this.index].visitStatCd !== '50') {
                                                this.show = 'F'
                                                return
                                            }

                                            if (this.$parent.$parent.today >= staDt && this.$parent.$parent.today <= endDt) {
                                                if (this.$parent.value[this.index].allowYn === 'Y')
                                                    this.show = 'Y'
                                                else
                                                    this.show = 'R'
                                            } else {
                                                this.show = 'F'
                                            }
                                        }
                                    }).catch((e) => {
                                        console.error(e);
                                    })
                                }
                            }
                        },
                        width: 75
                    },
                    {id: 'visitNo', type: 'ro', align: 'center', sort: 'na', value: '방문번호', width: 120},
                    {id: 'compNm', type: 'ro', align: 'center', sort: 'na', value: '방문회사', width: 120},
                    {id: 'visitorNm', type: 'ro', align: 'center', sort: 'na', value: '방문자명', width: 100},
                    {id: 'visitorComp', type: 'ro', align: 'center', sort: 'na', value: '방문자회사', width: 150},
                    {id: 'purposeNm', type: 'ro', align: 'center', sort: 'na', value: '방문목적', width: 80},
                    {id: 'visitYmd', type: 'ro', align: 'center', sort: 'na', value: '방문일', width: 80},
                    {id: 'inTime', type: 'ro', align: 'center', sort: 'na', value: '입실시간', width: 80},
                    {id: 'outYmd', type: 'ro', align: 'center', sort: 'na', value: '퇴실일', width: 80},
                    {id: 'outTime', type: 'ro', align: 'center', sort: 'na', value: '퇴실시간', width: 80},
                    {id: 'regDtm', type: 'ro', align: 'center', sort: 'na', value: '신청일', width: 80, hide: true},
                    {id: 'compCd', type: 'ro', align: 'center', sort: 'na', value: '회사코드', width: 100, hide: true},
                    {id: 'businessAreaNm', type: 'ro', align: 'center', sort: 'na', value: '사업장', width: 100, hide: true},
                    {id: 'visitDeptNm', type: 'ro', align: 'center', sort: 'na', value: '방문부서', width: 150, hide: true},
                    {id: 'visitEmpNm', type: 'ro', align: 'center', sort: 'na', value: '피방문자', width: 100},
                    {id: 'staYmd', type: 'ro', align: 'center', sort: 'na', value: '시작일', width: 80},
                    {id: 'staTime', type: 'ro', align: 'center', sort: 'na', value: '시작시간', width: 60, hide: true},
                    {id: 'endYmd', type: 'ro', align: 'center', sort: 'na', value: '종료일', width: 80},
                    {id: 'endTime', type: 'ro', align: 'center', sort: 'na', value: '종료시간', width: 60, hide: true},
                    {
                        id: 'secuYn',
                        value: '보안물품',
                        component: {
                            props: ['index', 'value', 'field'],
                            template: `
                                <div class="btn-wrapper" v-if="this.$parent.value[this.index]?.secuYn ==='Y'">
                                <button type="button" class="btn btn-primary btn-block" @click="showSecuDetail()">내역
                                </button>
                                </div>`,
                            methods: {
                                showSecuDetail() {
                                    this.$modal.open({
                                        component: SecuDetail,
                                        props: {
                                            visitNo: this.$parent.value[this.index].visitNo,
                                            visitorSeq: this.$parent.value[this.index].visitorSeq,
                                            visitorNm: this.$parent.value[this.index].visitorNm
                                        },
                                        parent: this,
                                        width: 1000
                                    })
                                },
                            }
                        },
                        width: 80
                    },
                    {
                        id: 'carYn',
                        value: '차량정보',
                        component: {
                            template: `
                                <div class="btn-wrapper" v-if="this.$parent.value[this.index]?.carYn ==='Y'">
                                <button type="button" class="btn btn-primary btn-block" @click="showCarDetail()">내역
                                </button>
                                </div>`,
                            methods: {
                                showCarDetail() {
                                    this.$modal.open({
                                        component: CarDetail,
                                        props: {
                                            visitNo: this.$parent.value[this.index].visitNo,
                                            visitorSeq: this.$parent.value[this.index].visitorSeq,
                                            visitorNm: this.$parent.value[this.index].visitorNm
                                        },
                                        parent: this,
                                        width: 800
                                    })
                                },
                            }
                        },
                        width: 80
                    },
                    {id: 'visitStatNm', type: 'ro', align: 'center', sort: 'na', value: '진행상태', width: 100},
                    {id: 'visitStatCd', type: 'ro', align: 'center', sort: 'na', value: '진행상태', width: 100, hide: true},
                    {id: 'visitorSeq', type: 'ro', align: 'center', sort: 'na', value: '방문자번호', width: 50, hide: true},
                    {id: 'seq', type: 'ro', align: 'center', sort: 'na', value: '방문기록번호', width: 50, hide: true},
                    {id: 'blackYn', align: 'center', value: '블랙여부', width: 100, hide: true},
                ],
                height: 483,
                enablePaging: true,
                pagingSize: 12,
                afterRefreshData(grid, data) {
                    this.$nextTick(() => {
                        _.forEach(data, (item, index) => {
                            let rId = index + 1
                            if (grid.cells(rId, 24).getValue() === 'Y') grid.setRowColor(rId, "coral");
                        })
                    })
                }
            },
            configExcel: {
                columns: [
                    {id: 'no', type: 'cntr', align: 'center', sort: 'na', value: 'No.', width: 35},
                    {id: 'visitNo', type: 'ro', align: 'center', sort: 'na', value: '방문번호', width: 120},
                    {id: 'compNm', type: 'ro', align: 'center', sort: 'na', value: '방문회사', width: 120},
                    {id: 'visitorNm', type: 'ro', align: 'center', sort: 'na', value: '방문자명', width: 100},
                    {id: 'visitorComp', type: 'ro', align: 'center', sort: 'na', value: '방문자회사', width: 150},
                    {id: 'purposeNm', type: 'ro', align: 'center', sort: 'na', value: '방문목적', width: 80},
                    {id: 'visitYmd', type: 'ro', align: 'center', sort: 'na', value: '방문일', width: 80},
                    {id: 'inTime', type: 'ro', align: 'center', sort: 'na', value: '입실시간', width: 80},
                    {id: 'outYmd', type: 'ro', align: 'center', sort: 'na', value: '퇴실일', width: 80},
                    {id: 'outTime', type: 'ro', align: 'center', sort: 'na', value: '퇴실시간', width: 80},
                    {id: 'regDtm', type: 'ro', align: 'center', sort: 'na', value: '신청일', width: 80, hide: true},
                    {id: 'compCd', type: 'ro', align: 'center', sort: 'na', value: '회사코드', width: 100, hide: true},
                    {id: 'businessAreaNm', type: 'ro', align: 'center', sort: 'na', value: '사업장', width: 100},
                    {id: 'visitDeptNm', type: 'ro', align: 'center', sort: 'na', value: '방문부서', width: 150},
                    {id: 'visitEmpNm', type: 'ro', align: 'center', sort: 'na', value: '피방문자', width: 100},
                    {id: 'staYmd', type: 'ro', align: 'center', sort: 'na', value: '시작일', width: 80},
                    {id: 'staTime', type: 'ro', align: 'center', sort: 'na', value: '시작시간', width: 60, hide: true},
                    {id: 'endYmd', type: 'ro', align: 'center', sort: 'na', value: '종료일', width: 80},
                    {id: 'endTime', type: 'ro', align: 'center', sort: 'na', value: '종료시간', width: 60, hide: true},
                    {id: 'secuYn', type: 'ro', align: 'center', sort: 'na', value: '보안물품', width: 80},
                    {id: 'carYn', type: 'ro', align: 'center', sort: 'na', value: '차량정보', width: 80},
                    {id: 'visitStatNm', type: 'ro', align: 'center', sort: 'na', value: '진행상태', width: 100},
                    {id: 'visitStatCd', type: 'ro', align: 'center', sort: 'na', value: '진행상태', width: 100, hide: true},
                    {id: 'visitorSeq', type: 'ro', align: 'center', sort: 'na', value: '방문자번호', width: 50, hide: true},
                    {id: 'seq', type: 'ro', align: 'center', sort: 'na', value: '방문기록번호', width: 50, hide: true},
                    {id: 'blackYn', align: 'center', value: '블랙여부', width: 100, hide: true},
                ],
                height: 483,
                enablePaging: true,
                pagingSize: 12,
                afterRefreshData(grid, data) {
                    this.$nextTick(() => {
                        _.forEach(data, (item, index) => {
                            let rId = index + 1
                            if (grid.cells(rId, 24).getValue() === 'Y') grid.setRowColor(rId, "coral");
                        })
                    })
                }
            },


            title: '마곡빌딩 방문객 리스트',
            params: {},
            docTypes: [],
            visitTypes: [],
            visitorStats: [],
            visitStats: [],
            visitList: [],
            visitBookYn: '',
            today: this.$moment().format('YYYYMMDD'),
            today2: this.$moment().format('YYYY-MM-DD'),
            checked: 'checked',
            showEmpModal: false,
            form: {
                docTypeCd: '',
                purpose: '',
                visitTypeCd: '',
                visitorStatCd: '',
                visitStatCd: '50',
                searchDtmFr: '',
                searchDtmTo: '',
                searchVDtmFr: this.$moment().format('YYYY-MM-DD'),
                searchVDtmTo: this.$moment().format('YYYY-MM-DD'),
                visitDept: '',
                visitEmp: '',
                visitorFirstNm: '',
                visitorComp: '',
                visitorNm: '',
                businessAreaCd: 'B1',
                visitCompCd: '',
                exceptToday: ''
            },
        };
    },
    methods: {
        constructGridSuccessful(grid) {
            this.config.queryPage(0)

            grid.attachEvent('onRowDblClicked', (rId) => {
                let visitNo = grid.cells(rId, 2).getValue();
                this.$router.push({path: `/backOffice/visitControlMgMng/${visitNo}`});
            });
        },
        getVisitTypeCdCombo() {
            this.$http.get(`/api/code/combo`, {params: {groupCd: "VISIT_TYPE_CD"}})
                    .then(response => {
                        this.visitTypes = response.data
                    })
        },
        getVisitorStatCdCombo() {
            this.$http.get(`/api/code/combo`, {params: {groupCd: "VISITOR_STAT_CD"}})
                    .then(response => {
                        this.visitorStats = response.data;
                    });
        },
        getVisitStatCdCombo() {
            this.$http.get(`/api/code/combo`, {params: {groupCd: "VISIT_STAT_CD", remark1: "Y"}})
                    .then(response => {
                        this.visitStats = response.data;
                    });
        },
        getDocTypeCombo() {
            this.$http.get(`/api/code/combo`, {params: {groupCd: "VISIT_TYPE_CD"}})
                    .then(response => {
                        this.docTypes = response.data;
                    });
        },
        saveExcel() {
            this.downloadExcel(this.$refs.gridExcel);
        },
        goSearch() {
            const param = JSON.parse(JSON.stringify(this.form));

            const stripFields = ['searchVDtmFr', 'searchVDtmTo'];
            _.forEach(stripFields, (name) => param[name] = this.toPure(param[name]));

            if (param.searchVDtmFr > param.searchVDtmTo) {
                this.$swal({type: 'warning', text: '방문 시작일자와 종료일자 지정이 잘못되었습니다.'});
                return false
            }

            param.exceptToday = param.exceptToday === true ? 'Y' : 'N'

            const searchInfo = {};
            Object.assign(searchInfo, this.form, {title: this.title});
            this.$store.commit('searchCondition', searchInfo);

            this.$store.commit('loading');
            this.$http.post(`/api/visit/visitor/ing/mgList`, param)
                    .then(response => {
                        if (response.data) {
                            this.visitList = response.data
                        }
                    }).finally(() => {
                this.$store.commit('finish')
            });
        },
        setToday() {
            this.form.searchVDtmFr = this.$moment().format('YYYY-MM-DD')
            this.form.searchVDtmTo = this.$moment().format('YYYY-MM-DD')
        },
        popEmp(clear) {
            if (clear === true) {
                this.form.draftUserId = '';
                this.form.draftNm = '';
                this.form.draftUserDut = '';
                this.form.draftUserDept = '';
            }
            this.showEmpModal = true;
        },
        receiveEmp(obj) {
            this.form.draftUserId = obj.empNo;
            this.form.draftNm = obj.empNm;
            this.form.draftUserDut = obj.dutNm;
            this.form.draftUserDept = obj.deptNm;
        },
        initEmp(force) {
            if (force === true) this.form.draftNm = '';
            if (this.form.draftNm === '') {
                this.form.draftUserId = '';
                this.form.draftUserDut = '';
                this.form.draftUserDept = '';
            }
        },
        getFuncUsed() {
            this.$http.get(`/api/func/getFuncUse`, {params: {funcCd: "VISIT_BOOK_YN"}})
                    .then(response => {
                        this.visitBookYn = response.data[0].adminFuncCd === 'Y' ? true : false
                    })
        }
    },
    computed: {
        isWait() {
            return this.form.visitorStatCd === 'OUT' ? true : false
        }
    },

    created() {
      //Admin 권한 체크
      if(this.$store.state.loginInfo.authorities[0].roleCd != "ADMIN") {
        setTimeout(()=> {
          this.$swal({type: 'warning', text: '관리자만 접속 가능합니다.'})
              ,100});
        this.$router.push({path: `/ijmt`});
      };
    },

    mounted() {
        if(this.$store.state.searchInfo !== null) {
            if (this.title === this.$store.state.searchInfo.title)
                Object.assign(this.form, this.$store.state.searchInfo);
            else
                this.$store.state.searchInfo = ''
        }
        this.getVisitStatCdCombo()
        this.getVisitorStatCdCombo()
        this.getVisitTypeCdCombo()
        this.getFuncUsed()
        this.goSearch()
    },
    watch: {
        'form.searchVDtmFr': {
            handler(value) {
                if (this.toPure(value) > this.toPure(this.form.searchVDtmTo))
                    this.form.searchVDtmTo = value
            }
        },
        'form.searchVDtmTo': {
            handler(value) {
                if (this.toPure(value) < this.toPure(this.form.searchVDtmFr))
                    this.form.searchVDtmFr = value
            }
        },
        'form.visitorStatCd': {
            handler(value) {
                if (value == 'OUT') {
                    this.form.visitStatCd = '50'
                } else if (value == 'DONE') {
                    this.form.searchVDtmFr = this.$moment().format('YYYY-MM-DD')
                    this.form.searchVDtmTo = this.$moment().format('YYYY-MM-DD')
                    this.form.visitStatCd = ''
                } else {
                    this.form.visitStatCd = ''
                }
            }
        },

    }
};
</script>

<style scoped>
.desc-content:after {
    clear: both;
    content: '';
    display: block;
}

.btn-wrap {
    margin-bottom: 10px;
}

.desc-content {
    border: 2px solid #9db6c9;
    background: #f9fafc;
    margin: 0 0 20px 0;
    border-radius: 4px;
    padding: 15px 2%;
    clear: both;
}

.desc-content .item {
    float: left;
}

.desc-content .item .desc-item {
    position: relative;
    padding-left: 82px;
    margin-bottom: 8px;
}

.desc-content .item.desc-center .desc-item {
    padding-left: 120px;
}

.desc-content .item .desc-item:last-child {
    margin-bottom: 0;
    height: 25px;
}

.desc-content .item .desc-item .tit {
    position: absolute;
    left: 0;
}

.desc-content .item .desc-item .label-tit {
    font-family: 'NotoM';
    color: #222;
    font-size: 15px;
}

.desc-content .item.desc-left .desc-item {
    padding-left: 90px;
}

.desc-content .item.desc-left .desc-item .desc:after {
    clear: both;
    content: '';
    display: block;
}

.desc-content .item.desc-left .desc-item .desc .datepicker {
    float: left;
}

.desc-content .item.desc-left .desc-item .desc span.wave {
    float: left;
    padding: 0 6px;
}

.desc-content .desc-item .td-s-thumb.search-area:after {
    clear: both;
    content: '';
    display: block;
}

.desc-content .desc-item .td-s-thumb.search-area input,
.desc-content .desc-item .td-s-thumb.search-area .ip-box {
    float: left;
}

.desc-content .item.desc-left .desc-item .desc.select select {
    width: 70%;
}

.desc-content .item.desc-left {
    width: 40%;
}

.desc-content .item.desc-center {
    width: 40%;
    padding-right: 40px;
}

.desc-content .item.desc-right {
    width: 20%;
}

.desc-content .item .desc-item .select select,
.desc-content .item .desc-item .input-box input {
    width: 70%;
}

.desc-content .item.desc-right .desc-item .select select,
.desc-content .item.desc-right .desc-item .input-box input {
    width: 100%;
}

.search-area input {
    position: relative;
}

.search-area .icon {
    position: absolute;
    right: 8px;
    top: 1px;
    z-index: 100;
    cursor: pointer;
    font-size: 16px;
    color: #555;
}

.search-border .td-s-thumb {
    position: relative;
    display: inline-block;
    width: 48%;
}

.search-border .td-s-thumb.search-area > input,
.search-border .td-s-thumb.search-area > .ip-box .search-border .td-s-thumb.search-area > button {
    float: left;
}

.search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
    width: 65%;
    margin-left: 6px;
}

.remove_text {
    margin-left: 0;
}

.contents div.gridbox_material.gridbox .xhdr {
    border-bottom: 1px solid #dfdfdf;
}

@media (max-width: 1580px) {
    .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
        width: 50%;
    }
}

textarea {
    height: 80px;
}

.search-form .form-group {
    margin-bottom: 8px
}
</style>
